export default "__VITE_ASSET__D05o81wY__"